import React from 'react';
import FolderDropdownContainer, { OwnProps } from './FolderDropdown.container';
import FolderDropdown from './FolderDropdown';

export default FolderDropdownContainer(FolderDropdown) as React.ComponentType<
  OwnProps
>;
